import React from 'react'
import styled from 'styled-components'
import Header from '~/components/Header/Header'
import FooterSection from '~/components/Footer'
const LayoutContainer = styled.div`
  background: #fff;
  position: relative;
`
// const ContainerContent = styled.div`
// `

const Layout: React.FC<{ webview: any }> = ({ webview, children }) => {
  return (
    <LayoutContainer className='layout'>
      {!webview &&
        <Header />
      }
      <div>
        {children}
      </div>
      {!webview &&
        <FooterSection />
      }
    </LayoutContainer>

  )
}

export default Layout